import React from 'react';
import { useSlate } from '|/context';
import { ReviewSummaryResponse } from '|/services/purchase-api';
import OrderSummaryCio from './cio';
import OrderSummaryControl from './control';
import OrderSummarySlate from './slate';

interface OrderSummaryProps {
  summary: ReviewSummaryResponse;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isCheckoutPage: boolean;
  onEditOrder: () => Promise<void>;
  // The checkout route renders the CIO summary unconditionally today, while the steps route
  // falls back to the pre-check-it-out one — so the arm differs by mount point.
  isCheckItOutTreatment: boolean;
}

const OrderSummary = ({ isCheckItOutTreatment, ...props }: OrderSummaryProps) => {
  const { isSlateVehicle } = useSlate();

  if (isCheckItOutTreatment) {
    // Slate keeps the pre-snapshot sheet until its own redesign ships. Every mount is
    // gated on the sheet being open, so the summary-fed flag is stable by the time
    // this renders — no resolved-wait needed.
    return isSlateVehicle ? <OrderSummarySlate {...props} /> : <OrderSummaryCio {...props} />;
  }

  return (
    <OrderSummaryControl
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      summary={props.summary}
    />
  );
};

export default OrderSummary;
